export default {
    seo: {
      title: 'Страхование вкладов | Банк 131',
      description: 'Страхование вкладов'
    },
    title: 'Страхование вкладов',
    content: [],
}